import React from "react";

import { Eyebrow, Title } from "../components/CommonComponents";

import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function VisionMission() {
  return (
    <>
      <MetaInfo param="" id="about" />

      <Header school="common" />

      <Footer />
    </>
  );
}
